import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { RouterModule } from '@angular/router';
import { FixedScrollDirective, OnOutsideClickDirective } from 'core/shared-components';
import { DsgTranslatePipe } from '../../pipes/translate.pipe';
import { ApplyClassOnChildDirective } from '../../shared-components/apply-class-on-child.directive';
import { LogoSoloComponent } from './logo-solo/logo-solo.component';
import { LogoComponent } from './logo/logo.component';
import { MobileToolbarComponent } from './mobile-toolbar/mobile-toolbar.component';
import { LanguageSelectComponent } from './sidenav-content/language-select/language-select.component';
import { SidenavContentComponent } from './sidenav-content/sidenav-content.component';
import { SidenavTreeComponent } from './sidenav-tree/sidenav-tree.component';
import { SidenavComponent } from './sidenav.component';
import { ToolbarSearchComponent } from './toolbar-search/toolbar-search.component';
import { UserMenuComponent } from './user-menu/user-menu.component';


@NgModule({
  declarations: [
    SidenavComponent,
    SidenavTreeComponent,
    SidenavContentComponent,
    LanguageSelectComponent,
    MobileToolbarComponent,
    UserMenuComponent,
    ToolbarSearchComponent

  ],
  exports: [SidenavComponent],
  imports: [
    CommonModule,
    LogoComponent,
    MatSidenavModule,
    MatTreeModule,
    RouterModule,
    MatButtonModule,
    MatIconModule,
    OnOutsideClickDirective,
    MatCardModule,
    MatSelectModule,
    DsgTranslatePipe,
    MatListModule,
    MatMenuModule,
    MatTooltipModule,
    RouterModule,
    OverlayModule,
    MatToolbarModule,
    FixedScrollDirective,
    MatInputModule,
    ApplyClassOnChildDirective,
    LogoSoloComponent

  ]
})
export class SidenavModule { }
